import { Box, styled } from '@mui/material';

export const TitleBox = styled(Box)`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const HeaderEdit = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0px 16px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 20px;

  .edit-dados {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 30%;
  }
  .add-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 24%;
  }
  .change-adm {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 17%;
  }
`;

export const Page = styled(Box)`
  .btn-save {
    width: 156px;
    height: 42px;
    position: fixed;
    right: 20px;
    bottom: 20px;
  }

  .title-admin {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }

  .btn-add-usuario {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 22px;
    gap: 8px;
    width: 100%;
    height: 42px;
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
  }
`;
